import { render, staticRenderFns } from "./commonDocsF.vue?vue&type=template&id=fd4f24fa"
import script from "./commonDocsF.vue?vue&type=script&lang=js"
export * from "./commonDocsF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports